<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.lock="loading">
        <div class="main-title">访客查看</div>
        <div class="vistor-wrap">
          <div class="vistor-top">
            <span
              :class="{ active: currentTab == item.id }"
              v-for="item in tab"
              :key="item.id"
              @click="changeTab(item.id)"
              >{{ item.title }}</span
            >
          </div>
          <div class="vistor-content" v-if="currentTab == 1">
            <div class="vistor-number">
              <div>
                店铺被访问次数<span>{{ companyPv }}</span>
              </div>
              <div>
                店铺被访问人数<span>{{ companyUv }}</span>
              </div>
            </div>
            <div class="seek-list">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
              >
                <el-table-column label="头像" width="80">
                  <template slot-scope="scope">
                    <img
                      style="width: 56px; height: 56px; border-radius: 50%"
                      v-if="scope.row.userAvator"
                      :src="$imgOssUrl + scope.row.userAvator.substring(1)"
                      alt=""
                    />
                    <div
                      v-else
                      style="
                        width: 56px;
                        height: 56px;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background: #f5f5f5;
                        color: #cfcfcf;
                        font-size: 28px;
                      "
                    >
                      <i class="el-icon-picture"></i>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="姓名"
                  prop="userName"
                  width="100"
                ></el-table-column>
                <el-table-column
                  label="职位"
                  prop="userDuty"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  label="公司名称"
                  prop="userCompanyName"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  label="所属行业"
                  prop="userIndustry"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  label="添加时间"
                  prop="create_time"
                  min-width="180"
                ></el-table-column>
              </el-table>
            </div>
            <el-pagination
              background
              v-if="totals > 0"
              class="main-page"
              layout="total, prev, pager, next"
              :current-page="page_no"
              :total="totals"
              @current-change="pageChange"
            >
            </el-pagination>
          </div>
          <div class="vistor-content" v-if="currentTab == 2">
            <div class="seek-list">
              <el-table
                ref="multipleTable"
                :data="tableProData"
                tooltip-effect="dark"
                style="width: 100%"
              >
                <el-table-column label="产品图片" width="120">
                  <template slot-scope="scope">
                    <img
                      style="width: 78px; height: 78px"
                      v-if="scope.row.imgs"
                      :src="scope.row.imgs[0]"
                      alt=""
                    />
                    <div
                      v-else
                      style="
                        width: 78px;
                        height: 78px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background: #f5f5f5;
                        color: #cfcfcf;
                        font-size: 28px;
                      "
                    >
                      <i class="el-icon-picture"></i>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="产品名称"
                  prop="goodsName"
                  min-width="100"
                ></el-table-column>
                <el-table-column
                  label="产品分类"
                  prop="classify.sf_class[0]"
                  min-width="120"
                ></el-table-column>
                <el-table-column label="操作" width="120" fixed="right">
                  <template slot-scope="scope">
                    <span class="check-btn" @click="edit(scope.row)"
                      >查看访问数据</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-pagination
              background
              v-if="totals > 0"
              class="main-page"
              layout="total, prev, pager, next"
              :current-page="page_no"
              :total="totals"
              @current-change="pageChange"
            >
            </el-pagination>
          </div>
        </div>
        <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 1">
            <div class="btn" @click="next('skip')">跳过</div>
            <div class="btn next-btn" @click="next('next')">下一步</div>
          </template>
          <!-- 可跳过无需验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 0">
            <div class="btn next-btn" @click="next('known')">完成</div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template v-if="detail.is_skip == 0 && detail.is_verify == 1">
            <div class="btn next-btn" @click="next('next')">下一步</div>
          </template>
        </div>
      </div>
      <!-- 询盘详情弹框 -->
      <el-dialog title="访问数据" :visible.sync="isShowDetail" width="845px">
        <div class="vistor-number">
          <div>
            店铺被访问次数<span>{{ companyPv }}</span>
          </div>
          <div>
            店铺被访问人数<span>{{ companyUv }}</span>
          </div>
        </div>
        <div class="seek-list">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            height="500"
          >
            <el-table-column label="头像" width="80">
              <template slot-scope="scope">
                <img
                  style="width: 56px; height: 56px; border-radius: 50%"
                  v-if="scope.row.userAvator"
                  :src="$imgOssUrl + scope.row.userAvator.substring(1)"
                  alt=""
                />
                <div
                  v-else
                  style="
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #f5f5f5;
                    color: #cfcfcf;
                    font-size: 28px;
                  "
                >
                  <i class="el-icon-picture"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="姓名"
              prop="userName"
              width="100"
            ></el-table-column>
            <el-table-column
              label="职位"
              prop="userDuty"
              min-width="120"
            ></el-table-column>
            <el-table-column
              label="公司名称"
              prop="userCompanyName"
              min-width="120"
            ></el-table-column>
            <el-table-column
              label="所属行业"
              prop="userIndustry"
              min-width="120"
            ></el-table-column>
            <el-table-column
              label="添加时间"
              prop="create_time"
              min-width="180"
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          v-if="totals > 0"
          class="main-page"
          layout="total, prev, pager, next"
          :current-page="page_no"
          :total="totals"
          @current-change="pageChange"
        >
        </el-pagination>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { skipOrReadStep, getCompanyPC, getProductListPC } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "visitorView",
  data() {
    return {
      loading: false,
      active: 2,
      detail: {},
      currentTab: 1,
      tab: [
        {
          id: 1,
          title: "店铺访问",
        },
        {
          id: 2,
          title: "产品访问",
        },
      ],
      companyPv: 0, //访问次数
      companyUv: 0, //访问人数
      tableData: [], //店铺数据
      tableProData: [], //产品数据
      page_no: 1,
      totals: 0,
      isShowDetail: false,
    };
  },
  mounted() {
    this.getData();
  },
  watch: {},
  methods: {
    getData() {
      let stepMenuList = JSON.parse(localStorage.getItem("menu"));
      this.stepMenuList = stepMenuList;
      var index = stepMenuList.findIndex(function (item) {
        return item.link_url == "visitorView";
      });
      this.detail = stepMenuList[index];
      this.active = index;
      //获取展商看板信息
      let data = this.$qs.stringify({
        carrier: "miniapp",
        data_type: "展商",
        page_no: this.page_no,
        page_size: 10,
      });
      this.getCompanyData(data);
    },
    //切换tab
    changeTab(id) {
      this.currentTab = id;
      this.page_no = 1;
      if (this.currentTab == 1) {
        let data = this.$qs.stringify({
          carrier: "miniapp",
          data_type: "展商",
          page_no: this.page_no,
          page_size: 10,
        });
        this.getCompanyData(data);
      } else {
        this.getProductListData();
      }
    },
    //获取展商看板信息
    getCompanyData(data, type) {
      this.loading = true;
      getCompanyPC(data)
        .then((res) => {
          this.loading = false;
          if (res.data.code == 1) {
            let { data } = res.data;
            this.tableData = data.user_list;
            this.companyPv = data.pv ? data.pv : 0;
            this.companyUv = data.uv ? data.uv : 0;
            this.totals = data.total;
            if(type){
              this.isShowDetail = true;
            }
          }
        })
        .catch((err) => {});
    },
    //获取产品信息
    getProductListData() {
      this.loading = true;
      let data = this.$qs.stringify({
        page_no: this.page_no,
        page_size: 10,
      });
      getProductListPC(data)
        .then((res) => {
          this.loading = false;
          if (res.data.code == 1) {
            let { data } = res.data;
            this.tableProData = data.list;
            this.totals = data.total;
          }
        })
        .catch((err) => {});
    },
    // 分页切换
    pageChange(val) {
      this.page_no = val;
      if (this.currentTab == 1) {
        this.getCompanyData();
      } else {
        this.getProductListData();
      }
    },
    //查看访问数据
    edit(row) {
      let data = this.$qs.stringify({
        carrier: "miniapp",
        data_type: "展品",
        productId: row.id,
        page_no: this.page_no,
        page_size: 10,
      });
      this.tableData = [];
      this.getCompanyData(data, '展品');
    },
    // 跳转下一步
    next(type) {
      if (type == "next") {
        //下一步
        if (this.detail.action == 1 || this.detail.action == 4) {
          this.toPath();
        } else {
          this.$message.warning("请完善信息!");
        }
      } else if (type == "skip") {
        //跳过
        this.skipOrReadStep(1);
      } else if (type == "known") {
        //已知悉
        this.skipOrReadStep(2);
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action) {
      let data = {
        action,
        mark: this.detail.mark,
      };
      skipOrReadStep(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success("操作成功");
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPath() {
      this.active = this.active + 1;
      let { link_url, id } = this.stepMenuList[this.active];
      if (link_url == "conference") {
        this.$router.push({
          path: link_url,
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin-bottom: 0;
  .vistor-wrap {
    padding: 20px;
    margin-top: 20px;
    background: #fff;
    border-radius: 10px;
    position: relative;
    min-height: calc(100vh - 350px);
    .vistor-top {
      margin-bottom: 20px;
      span {
        width: 126px;
        height: 40px;
        line-height: 40px;
        background: #fff;
        border-radius: 6px;
        text-align: center;
        display: inline-block;
        font-size: 14px;
        color: #7f8fa4;
        cursor: pointer;
        margin-right: 25px;
        border: 1px solid #e9e9e9;
      }
      .active {
        color: #fff;
        border-color: #fc933f;
        background: #fc933f;
      }
    }
    .check-btn {
      color: #3d83e9;
      cursor: pointer;
      font-weight: 500;
    }
    .check-btn:hover {
      text-decoration: underline;
    }
  }
}
.vistor-number {
  font-size: 14px;
  color: #333;
  height: 62px;
  display: flex;
  line-height: 62px;
  padding: 0 15px;
  margin: 0 0 20px;
  background: #f7faff;
  > div {
    margin-right: 50px;
    span {
      color: #000;
      font-weight: 500;
      font-size: 18px;
      margin-left: 20px;
    }
  }
}
.main-page {
  width: 100%;
  padding: 0 20px;
  margin-top: 30px;
  text-align: right;
  box-sizing: border-box;
}
.conf-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 148px;
    height: 40px;
    cursor: pointer;
    font-size: 19px;
    margin: 0 10px;
    font-weight: 500;
    color: #2690e6;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #008dff;
    &:hover {
      text-decoration: underline;
    }
  }
  .next-btn {
    color: #fff;
    background: #008dff;
  }
}
/deep/ .el-dialog {
  border-radius: 10px;
}
@media only screen and (max-width: 767px){
  .content{
    margin: 0;
    padding: 10px 20px 190px 20px;
  }
}
</style>